export const COOKIE_NAMES = [
  'elements.user.size_of_heated_area',
  'elements.user.heating_elements',
  'elements.user.heating_water',
  'elements.user.building_type',
  'elements.user.technology_type',
  'elements.user.owner_or_tenant',
  'elements.user.house_type',
  'elements.user.private_or_commercial',
  'elements.user.current_energy_type',
  'elements.user.location_of_heating_system',
  'elements.user.interest_future_heating',
  'elements.user.heating_time',
  'elements.user.pellet.gas',
  'elements.user.pellet.oil',
  'elements.user.household_persons',
  'elements.user.heating_hybrid',
  'elements.user.house_year',
  'elements.user.house_renovation',
  'elements.user.location_of_heatpump',
  'elements.user.house_foundation',
  'elements.user.house_distance',
  'elements.user.heating_solar_additional',
  'elements.user.heating_results',
  'elements.user.heating_result'
];

export function mapCookieName(key) {
  console.log('KEY', key);
  if (key.startsWith('beheizteFlaeche')) {
    return 'elements.user.size_of_heated_area';
  }

  if (key.startsWith('b2cHeizkoerperart')) {
    return 'elements.user.heating_elements';
  }

  if (key.startsWith('artWarmwasserbereitung')) {
    return 'elements.user.heating_water';
  }

  switch (key) {
    case 'gebaeudeTyp':
      return 'elements.user.building_type';
    case 'energieTraeger':
      return 'elements.user.technology_type';
    case 'eigentumsVerhaeltnis':
      return 'elements.user.owner_or_tenant';
    case 'gebaeudeVermietet':
      return 'elements.user.house_type';
    case 'immobilienNutzung':
      return 'elements.user.private_or_commercial';
    // case 'beheizteFlaeche_type3':
    //   return 'elements.user.size_of_heated_area';
    case 'bestehendeBrennstoffversorgung':
      return 'elements.user.current_energy_type';
    case 'bestehendeBrennstoffversorgung_wohnung':
      return 'elements.user.current_energy_type';
    case 'schornstein':
      return 'elements.user.location_of_heating_system';
    case 'schornstein_mehrfamilienhaus':
      return 'elements.user.location_of_heating_system';
    case 'zukuenftigeBrennstoffversorgung':
      return 'elements.user.interest_future_heating';
    case 'zukuenftigeBrennstoffversorgung_mehrfamilienhaus':
      return 'elements.user.interest_future_heating';
    case 'umbauPlan':
      return 'elements.user.heating_time';
    case 'pelletLagerung_gas':
      return 'elements.user.pellet.gas';
    case 'pelletLagerung_oel':
      return 'elements.user.pellet.oil';
    case 'pvVerbrauchBasis':
      return 'elements.user.household_persons';
    case 'wpHybrid':
      return 'elements.user.heating_hybrid';
    case 'wpBaujahr':
      return 'elements.user.house_year';
    case 'wpSanierungStand':
      return 'elements.user.house_renovation';
    case 'aufstellungWP':
      return 'elements.user.location_of_heatpump';
    case 'untergrundWP':
      return 'elements.user.house_foundation';
    case 'entfernungWP':
      return 'elements.user.house_distance';
    case 'untergrundWPM':
      return 'elements.user.house_foundation';
    case 'entfernungWPM':
      return 'elements.user.house_distance';
    case 'zusatzSolar':
      return 'elements.user.heating_solar_additional';
    // case '':
    //   return 'elements.user.heating_results';
    default:
      return null;
  }
}

export function mapPageAndResponseToCookie(page, response) {
  const name = mapCookieName(response.key);
  if (!name) {
    console.log('mapPageToCookieValue: no mapped cookie name for ', response.key);
    return undefined;
  }

  let value = '';
  if (Array.isArray(response.value)) {
    console.log('mapPageToCookieValue: ISARRAY');
    response.value.map(arrayValue => {
      const comma = value !== '' ? ', ' : '';
      const filteredValue = page.answers.filter(el => {
        if (isNaN(parseInt(el.value))) {
          return el.value === arrayValue
        } else {
          return parseInt(el.value) === parseInt(arrayValue)
        }
      })
      value += comma;
      value += filteredValue[0] ? filteredValue[0].label : typeof arrayValue === 'string' ? arrayValue : filteredValue.label
    })
  } else {
    const filteredValue = page.answers.filter(el => {
      if (isNaN(parseInt(el.value))) {
        return el.value === response.value
      } else {
        return parseInt(el.value) === parseInt(response.value)
      }
    })

    if (response.key === 'bestehendeBrennstoffversorgung' && parseInt(response.value) === 4) {
      value = 'Strom'
    } else {
      value = filteredValue[0] ? filteredValue[0].label : typeof response.value === 'string' ? response.value : filteredValue.label
    }

    console.log('mapPageToCookieValue: VALUE', value);
  }
  console.log('mapPageToCookieValue: COOKIE', {cookieName: name, cookieValue: value});
  return {name, value};
}
